/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, submitDrivableClaim } from '../../../actions/claimSubmitActions';
import { showDrivabeClaimRecordModal, showDrivabeClaimSomeOneElseModal } from '../../../actions/modalActions';

class FnolStep10Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleClaimKP = this.handleClaimKP.bind(this);
        this.handleClaimOther = this.handleClaimOther.bind(this);
        this.handleRecordPurposes = this.handleRecordPurposes.bind(this);
    }

    async handleClaimKP(value: string) {
        var recordPurpose = value === 'record' ? true : false
        var thirdParty = value === 'thirdparty' ? true : false
        if (recordPurpose) {
            await this.props.handleRecordModal();
        }
        else if (thirdParty) {
            await this.props.handleSomeOneElseModal();
        } else {
            await this.props.dispatchSubmitDrivableClaim(recordPurpose, thirdParty);
            await this.props.dispatchHandleNextStep();
        }
    }

    async handleClaimOther() {
        await this.props.handleSomeOneElseModal();
    }

    async handleRecordPurposes() {
        await this.props.handleRecordModal();
    }

    handleCallMeBack() {
        this.props.dispatchShowCallMeBack()
    }

    public render() {
        const redArrow = "/my-policy/Images/Claims/dropdown-red.png";
        const whiteArrow = "/my-policy/Images/Claims/dropdown-white.png";

        return (
            <div className="col ssp-container-fnol-drivable ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-drivable">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>Finalise details</h3>
                            </div>
                        </div>
                    </div>
                </div>  
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <div className="mb-15px">
                            <p className="mb-0px line-height-1-43">What would you like to do with the claim info you've submitted</p>
                        </div>
                        <div className="row nopa noma">
                            <button className="hover-button btn btn-outline-red mt-10px mb-5px w-100 h-100 text-left drivableClaimFinalDetails" id="btn-kp" onClick={() => this.handleClaimKP("claimKP")}>
                                <div className="row align-items-center mr-auto">
                                    <div className="col">
                                        I want to claim from King Price
                                    </div>
                                    <img className="hover-button-off" src={redArrow} alt="" title="" />
                                    <img className="hover-button-on" src={whiteArrow} alt="" title="" />
                                </div>
                            </button>
                            <button className="hover-button btn btn-outline-red mt-10px mb-5px w-100 h-100 text-left drivableClaimFinalDetails" id="btn-claim-not-kp" onClick={() => this.handleClaimKP("thirdparty")}>
                             <div className="row align-items-center mr-auto">
                                <div className="col">
                                 I want to claim from a third party (not King Price)
                                </div>
                                    <img className="hover-button-off" src={redArrow} alt="" title="" />
                                    <img className="hover-button-on" src={whiteArrow} alt="" title="" />
                             </div>
                            </button>
                            <button className="hover-button btn btn-outline-red mt-10px mb-5px w-100 h-100 text-left drivableClaimFinalDetails" id="btn-kp-record" onClick={() => this.handleClaimKP("record")}>
                             <div className="row align-items-center mr-auto">
                                <div className="col">
                                 I want to report this incident for record purposes
                                    </div>
                                    <img className="hover-button-off" src={redArrow} alt="" title="" />
                                    <img className="hover-button-on" src={whiteArrow} alt="" title="" />
                             </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSubmitDrivableClaim: (isRecordPurpose, isThirdPartyclaim) => dispatch(submitDrivableClaim(isRecordPurpose, isThirdPartyclaim)),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        handleSomeOneElseModal: () => dispatch(showDrivabeClaimSomeOneElseModal()),
        handleRecordModal: () => dispatch(showDrivabeClaimRecordModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep10Sub1)